import React from "react";
import { TranslateContext } from "../../../context/TranslateContext";
import {
  Box,
  CardMedia,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
  alpha,
  Container,
} from "@mui/material";
import { DarkMode, LightMode, Logout } from "@mui/icons-material";
import ChangeLang from "../../../components/ChangeLang";

const Header = () => {
  const { data } = React.useContext(TranslateContext);
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        backdropFilter: "blur(10px)",
        bgcolor: alpha(theme.palette.background.paper, 0.8),
        position: "sticky",
        top: 0,
        zIndex: 1000,
        boxShadow: `0 2px 10px ${alpha(theme.palette.common.black, 0.05)}`,
      }}
    >
      <Container maxWidth="lg">
        <Box py={2}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Logo Section */}
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box
                sx={{
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: -4,
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha(
                      theme.palette.primary.main,
                      0.2,
                    )}, ${alpha(theme.palette.secondary.main, 0.2)})`,
                    animation: "pulse 3s ease-in-out infinite",
                  },
                  "@keyframes pulse": {
                    "0%, 100%": { opacity: 0.5 },
                    "50%": { opacity: 1 },
                  },
                }}
              >
                <CardMedia
                  component="img"
                  src="/assets/logo.png"
                  sx={{
                    height: 45,
                    width: 45,
                    borderRadius: 2.5,
                    position: "relative",
                    zIndex: 1,
                    boxShadow: `0 4px 12px ${alpha(
                      theme.palette.primary.main,
                      0.3,
                    )}`,
                  }}
                />
              </Box>
              <Typography
                variant="h6"
                fontWeight={700}
                sx={{
                  display: { xs: "none", sm: "block" },
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Dashboard
              </Typography>
            </Stack>

            {/* Actions */}
            <Stack direction="row" alignItems="center" spacing={1}>
              <ChangeLang />

              <Tooltip title={data.logout} arrow>
                <IconButton
                  onClick={() => {
                    localStorage.removeItem(
                      process.env.REACT_APP_TOKEN + "_user",
                    );
                    window.location.reload();
                  }}
                  sx={{
                    bgcolor: alpha(theme.palette.error.main, 0.1),
                    color: "error.main",
                    "&:hover": {
                      bgcolor: alpha(theme.palette.error.main, 0.2),
                      transform: "scale(1.05)",
                    },
                    transition: "all 0.2s",
                  }}
                >
                  <Logout fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip
                title={
                  localStorage.getItem("theme") === "dark"
                    ? "Light Mode"
                    : "Dark Mode"
                }
                arrow
              >
                <IconButton
                  onClick={() => {
                    const newTheme =
                      localStorage.getItem("theme") === "dark"
                        ? "light"
                        : "dark";
                    localStorage.setItem("theme", newTheme);
                    window.location.reload();
                  }}
                  sx={{
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: "primary.main",
                    "&:hover": {
                      bgcolor: alpha(theme.palette.primary.main, 0.2),
                      transform: "rotate(180deg)",
                    },
                    transition: "all 0.4s",
                  }}
                >
                  {localStorage.getItem("theme") === "dark" ? (
                    <LightMode fontSize="small" />
                  ) : (
                    <DarkMode fontSize="small" />
                  )}
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
